import React, { useState } from "react";
import emailjs from 'emailjs-com';
import { supabase } from "../../lib/supabase";
import "../stylescss/FormularioCursos.css";

const FormularioCursos = () => {
  const [form, setForm] = useState({
    nombre: "",
    paterno: "",
    materno: "",
    telefono: "",
    correo: "",
    dni: "",
    curso: ""
  });

  const [enviando, setEnviando] = useState(false);

  const cursos = [
    "GESTIÓN PÚBLICA ESTRATÉGICA Y PLANEAMIENTO",
    "FINANZAS PÚBLICAS",
    "SISTEMA NACIONAL DE ABASTECIMIENTO",
    "INVERSIÓN PÚBLICA",
    "GESTIÓN DE OBRAS PÚBLICAS",
    "DERECHO PENAL EN LA FUNCIÓN PÚBLICA",
    "GESTIÓN PÚBLICA EN SALUD",
    "GESTIÓN DE BIBLIOTECA",
    "GESTIÓN MUNICIPAL",
    "GESTIÓN AMBIENTAL",
    "ALIMENTACIÓN Y NUTRICIÓN",
    "JARDINERÍA, PODA DE ÁRBOLES Y TRABAJO EN ALTURA",
    "GESTIÓN DE RECURSOS HUMANOS Y SERVICIO CIVIL",
    "GESTIÓN JURÍDICA Y ADMINISTRATIVA",
    "CONTROL, AUDITORÍA Y ÉTICA PÚBLICA",
    "DERECHO LABORAL",
    "HABILIDADES BLANDAS",
    "GESTIÓN MINERA",
    "TRABAJO SOCIAL",
    "OFIMÁTICA",
    "INTELIGENCIA ARTIFICIAL Y CIENCIA DE DATOS",
    "CONTENIDO Y REDACCIÓN DIGITAL",
    "SQL SERVER",
    "ADOBE PHOTOSHOP, ILLUSTRATOR E INDESIGN",
    "MS PROJECT",
    "GESTIÓN DE PROYECTOS BIM",
    "PREVENCIÓN Y SEGURIDAD VIAL",
    "PAISAJISMO, JARDINERÍA Y PODA DE ÁRBOLES",
    "GESTIÓN DE RIESGOS DE DESASTRES",
    "GESTIÓN DE SERVICIOS Y ATENCIÓN AL CIUDADANO",
    "GESTIÓN EMPRESARIAL",
    "Diploma en Gestión Pública Moderna",
    "Diploma en Planeamiento Estratégico",
    "Diploma en Presupuesto por Resultados",
    "Diploma en Invierte.pe",
    "Diploma en Sistemas Administrativos del Estado",
    "Diploma en Contrataciones del Estado",
    "Diploma en Sistema Nacional de Abastecimiento",
    "Diploma en Auditoría Gubernamental",
    "Diploma en Derecho Administrativo",
    "Diploma en Ética e Integridad Pública",
    "Diploma en Gestión de Recursos Humanos",
    "Diploma en Liderazgo y Equipos",
    "Diploma en Transformación Digital",
    "Diploma en Gestión Documental",
    "Diploma en Ofimática Profesional",
    "Diploma en Gestión de Obras Públicas",
    "Diploma en Gestión Pública en Salud",
    "Diploma en Gestión Ambiental",
    "Diploma en Gestión de Proyectos",
    "Diploma en Gestión Empresarial",
    "CURSOS INHOUSE"
  ];

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const mostrarNotificacion = (mensaje, tipo = 'exito') => {
    const notificacion = document.createElement('div');
    notificacion.textContent = mensaje;
    notificacion.className = `notificacion-toast ${tipo === 'error' ? 'error' : ''}`;
    document.body.appendChild(notificacion);
    setTimeout(() => notificacion.remove(), 3000);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEnviando(true);

    if (!form.nombre || !form.paterno || !form.telefono || !form.correo || !form.dni || !form.curso) {
      mostrarNotificacion("⚠️ Completa todos los campos obligatorios", "error");
      setEnviando(false);
      return;
    }

    supabase.from("inscripciones").insert([
      {
        nombre: form.nombre,
        paterno: form.paterno,
        materno: form.materno,
        telefono: form.telefono,
        correo: form.correo,
        dni: form.dni,
        curso: form.curso,
      },
    ]).then(({ error }) => {
      if (error) {
        console.error(error);
        mostrarNotificacion("❌ Error al guardar la inscripción. Intenta de nuevo.", "error");
        setEnviando(false);
        return;
      }

      const nombreCompleto = `${form.nombre} ${form.paterno} ${form.materno}`;
      const templateParams = {
        nombre_completo: nombreCompleto,
        dni: form.dni,
        telefono: form.telefono,
        correo: form.correo,
        curso: form.curso,
      };

      emailjs.send(
        'service_qbxpuw9',
        'template_6gbngjh',
        templateParams,
        'a43-B8VoB8yaaYSF3'
      ).then(
        (result) => {
          console.log('Correo enviado:', result.text);
          mostrarNotificacion(" ✅ Inscripción guardada y correo enviado correctamente.");
          
          setForm({
            nombre: "",
            paterno: "",
            materno: "",
            curso: "",
            telefono: "",
            correo: "",
            dni: ""
          });
          setEnviando(false);
        },
        (error) => {
          console.error('Error EmailJS:', error);
          mostrarNotificacion("✅ Inscripción guardada, pero el correo no pudo enviarse.", "error");
          setEnviando(false);
        }
      );
    });
  };

  return (
    <section className="form-section">
      <div className="form-container">
        <div className="form-header">
          <div>
            <h2>Inscríbete a nuestros cursos</h2>
            <p>Completa tus datos y un asesor se pondrá en contacto contigo.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="form-grid">
          <div className="form-field">
            <label htmlFor="nombre">Nombre</label>
            <input id="nombre" type="text" name="nombre" placeholder="Tu nombre" onChange={handleChange} value={form.nombre} required />
          </div>

          <div className="form-field">
            <label htmlFor="paterno">Apellido Paterno</label>
            <input id="paterno" type="text" name="paterno" placeholder="Apellido paterno" onChange={handleChange} value={form.paterno} required />
          </div>

          <div className="form-field">
            <label htmlFor="materno">Apellido Materno</label>
            <input id="materno" type="text" name="materno" placeholder="Apellido materno" onChange={handleChange} value={form.materno} required />
          </div>

          <div className="form-field">
            <label htmlFor="telefono">Teléfono</label>
            <input id="telefono" type="tel" name="telefono" placeholder="999 999 999" onChange={handleChange} value={form.telefono} required />
          </div>

          <div className="form-field">
            <label htmlFor="correo">Correo</label>
            <input id="correo" type="email" name="correo" placeholder="tucorreo@email.com" onChange={handleChange} value={form.correo} required />
          </div>

          <div className="form-field">
            <label htmlFor="dni">DNI</label>
            <input id="dni" type="text" name="dni" placeholder="Nº de documento" onChange={handleChange} value={form.dni} required />
          </div>

          <div className="form-field form-field--full">
            <label htmlFor="curso">Curso de interés</label>
            <select id="curso" name="curso" onChange={handleChange} value={form.curso} required defaultValue="">
              <option value="" disabled>Seleccione un curso</option>
              {cursos.map((curso, index) => (
                <option key={index} value={curso}>{curso}</option>
              ))}
            </select>
          </div>

          <div className="form-field form-field--full">
            <button className="form-enviar" type="submit" disabled={enviando}>
              {enviando ? "Enviando..." : "Enviar inscripción"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default FormularioCursos;